<template>
  <v-card
      flat
      rounded="0"
      class="mx-auto mt-4"
      max-width="600"
      mim-width="350"
  >
    <v-card
        width="auto"
        height="auto"
        flat>
      <v-container class="pa-2" fluid>
        <v-row class="pa-0">
          <v-col cols="12" class="pa-0">
            <v-card-title class="pt-0 font-weight-bold text-body-1">
              {{ upjangInfo.upjang_name }}
            </v-card-title>
          </v-col>
        </v-row>

        <v-divider class="mt-3 mb-5"></v-divider>

        <v-container v-if="!isEmpty" class="pa-0" v-for="(item, index) in items">
          <v-card v-if="!item.disable" class="mt-2 mb-2 pl-4 pr-4" color="grey-lighten-4" flat>
            <v-row class="pa-0">
              <v-col cols="10" class="pa-0 pt-3">
                <v-card-title class="font-weight-bold text-body-1">
                  {{ item.menu_name }}
                </v-card-title>
              </v-col>
              <v-col cols="2">
                <v-btn
                    class="w-100 justify-end align-end"
                    icon
                    @click="deleteItem(index)"
                    density="comfortable"
                    variant="plain">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="align-center pa-0 pb-4">
              <v-col cols="5" class="d-flex align-center">
                <v-btn icon
                       color="primary"
                       class="mr-2"
                       @click="decrement(index, item.sale_cnt, item.sale_price)"
                       density="compact"
                       variant="outlined">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <v-text-field
                    v-model.number="item.sale_cnt"
                    class="bg-white pa-0"
                    style="'padding-right: 8px;padding-left: 8px;'"
                    density="compact"
                    variant="outlined"
                    type="number"
                    min="2"
                    :readonly=true
                    single-line
                    hide-details
                >
                </v-text-field>
                <v-btn icon
                       color="primary"
                       class="ml-2"
                       @click="increment(index, item.sale_cnt, item.sale_price, item.limit_yn, item.remain_cnt)"
                       density="compact"
                       variant="outlined">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="3.5" class="pl-0 pr-0">
                <v-card-text v-if="item.limit_yn === 'Y'" class="pa-0 text-caption text-start">
                  (남은수량: {{item.limit_cnt}}개)
                </v-card-text>
              </v-col>
              <v-col cols="3.5" class="pl-0">
                <v-card-text class="pa-0 font-weight-bold text-body-1 text-end">
                  {{ formatAmt(item.sale_amt) || '-'}}
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-container>

        <v-card v-if="isEmpty" class="pl-4 pr-4" color="grey-lighten-4" flat>
          <v-card-text class="text-body-2 text-center">
            장바구니에 상품이 없습니다.
          </v-card-text>
          <v-card-text class="pt-0 text-center">
            <v-btn color="primary" to="/upjang" variant="tonal" size="small">주문하러가기</v-btn>
          </v-card-text>
        </v-card>

        <v-divider class="mt-5 mb-5"></v-divider>

        <v-card class="pa-2" color="grey-lighten-4" flat>
          <v-row class="ma-2">
            <v-card-text class="pa-0 font-weight-bold text-body-1 text-start">
              총 주문금액
            </v-card-text>
            <v-card-text class="pa-0 font-weight-bold text-body-1 text-end">
              {{ formatAmt(totalPrice) || '-' }}
            </v-card-text>
          </v-row>
        </v-card>

        <v-divider class="mt-5 mb-5"></v-divider>

        <v-card class="pa-2" color="grey-darken-2" variant="outlined">
          <v-card-text class="pa-0 text-body-2 text-start">
            최종결제시 <b>수령방법</b>에 따라 <b>배송비</b>가 발생할수 있습니다.
          </v-card-text>
        </v-card>
      </v-container>
    </v-card>

    <v-row v-if="!this.$vuetify.display.mobile" class="mt-5">
      <v-col cols="6" class="pl-0 pr-0">
        <v-card-actions class="justify-end">
          <v-btn size="large" class="w-50 text-body-2 bg-primary" @click="goUpjangPage()">계속주문</v-btn>
        </v-card-actions>
      </v-col>
      <v-col cols="6" class="pl-0 pr-0">
        <v-card-actions class="justify-start">
          <v-btn size="large" class="w-50 text-body-2 bg-primary" @click="order()">주문하기</v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>

  <v-bottom-navigation v-if="this.$vuetify.display.mobile" class="bg-primary">
    <v-btn class="w-50 text-body-2" @click="goUpjangPage()">계속주문</v-btn>
    <v-btn class="w-50 text-body-2" @click="order()">주문하기</v-btn>
  </v-bottom-navigation>
</template>

<script>
import {cart, upjang} from "@/api";
import authStore from "@/store/auth";
import commonStore from "@/store/common";
import cartStore from "@/store/cart";
import shotUrlStore from "@/store/shotUrl";

export default {
  name: "Cart",
  data () {
    return {
      isAuth: false,
      items: [],
      upjangInfo: {},
      totalPrice:0,
      isEmpty: true,
    }
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    },
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    this.getCartItemList()
    this.checkCart()
  },
  methods: {
    getCartItemList() {
      cart.getCartItemList(commonStore.state.common.corpCode, cartStore.state.cart.cartKey)
          .then(data => {
            console.log(data)
            if (data.data.items && data.data.items.length > 0) {
              this.items = data.data.items
              this.items.forEach((item) => {
                item.disable = false
                this.totalPrice += item.sale_amt
              })
              this.isEmpty = false
            } else {
              cartStore.dispatch('removeCartInfo')
            }

            if (data.data.upjang_code && data.data.upjang_name) {
              this.upjangInfo = {
                upjang_code: data.data.upjang_code,
                upjang_name: data.data.upjang_name
              }

              this.getUpjangInfo(this.upjangInfo.upjang_code)
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    checkCart() {
      if(!cartStore.state.cart.cartKey || cartStore.state.cart.cartKey == 'null') return false

      cart.checkCart(commonStore.state.common.corpCode, cartStore.state.cart.cartKey)
          .then(data => {
            console.log(data)
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
              cartStore.dispatch('removeCartInfo')
              shotUrlStore.dispatch('removeRouterInfo')
              this.$router.push('/upjang')
            }
          })
    },
    getUpjangInfo(upjangCode) {
      if (!upjangCode) {
        return
      }

      upjang.getUpjangInfo(commonStore.state.common.corpCode, upjangCode)
          .then(data => {
            console.log(data)
            if (data.data) {
              this.upjangInfo.minimum_oamt = parseInt(data.data.minimum_oamt)
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    deleteItem(index) {
      this.items[index].sale_cnt = 0
      this.items[index].sale_amt = 0
      this.totalPrice = 0
      this.items[index].disable = true

      cart.removeCartItem(commonStore.state.common.corpCode,
          this.items[index].cart_key,
          this.items[index].seq_no,
          this.items[index].menu_code)

      let flag = true;
      this.items.forEach((item) => {
        this.totalPrice += item.sale_amt
        flag *= item.disable
      })
      this.isEmpty = flag

      if (this.isEmpty) {
        cartStore.dispatch('removeCartInfo')
      }
    },
    async order() {
      if (this.totalPrice <= 0) {
        alert("결제 할 수 있는 상품이 없습니다.")
        return
      }

      if (this.upjangInfo.minimum_oamt > this.totalPrice) {
        alert("최소 주문금액은 " + this.formatAmt(this.upjangInfo.minimum_oamt) + " 입니다.")
        return
      }

      const requests = this.items.map(item => cart.updateCart(commonStore.state.common.corpCode, item.upjang_code, item.menu_code, item.sale_cnt, item.cart_key))

      try {
        await Promise.all(requests);
        console.log('-');

        this.$router.push('/order')
      } catch (error) {
        alert("주문 페이지로 이동중 에러가 발생했습니다.\n" + error)
      }

    },
    goUpjangPage() {
      if (this.upjangInfo.upjang_code) {
        this.$router.push('/upjang/' + this.upjangInfo.upjang_code)
      } else {
        this.$router.push('/upjang')
      }
    },
    increment (index, count, price, limitYn, remainCount) {
      if (limitYn === 'Y' && (count >= remainCount)) {
        alert("구매 가능한 수량이 없습니다.\n더 이상 상품을 추가할 수 없습니다.")
        return
      }
      count = parseInt(count,10) + 1
      this.items[index].sale_cnt = count
      this.items[index].sale_amt = price * count
      this.totalPrice = 0
      this.items.forEach((item) => {
        this.totalPrice += item.sale_amt
      })
    },
    decrement (index, count, price) {
      if (count === 0) {
        return
      }
      count = parseInt(count,10) - 1
      this.items[index].sale_cnt = count
      this.items[index].sale_amt = price * count
      this.totalPrice = 0
      this.items.forEach((item) => {
        this.totalPrice += item.sale_amt
      })
    },
  }
}
</script>

<style scoped>
/deep/ .v-text-field{ width: 50px; }
/deep/ .v-field__input { padding: 8px; text-align: center; }
</style>